import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Token',
    entityNamePlural: 'Tokens',
    entityNameModule: 'admin',
    basePath: '/admin/tokens',
  }), [])
}
